import React from 'react';
import gql from 'graphql-tag';
import useQuery from '../../hooks/useQuery';
import useCurrentBuilderPage from '../../../../admin/hooks/useCurrentBuilderPage';
import Editor from './Editor';

export const GET_FACILITIES = gql`
  query GetFacilities($live: Boolean!, $locale: String!) {
    facilities(filter: { live: $live, locale: $locale }) {
      edges {
        node {
          id
          ...FacilityGroupWidgetEditor
        }
      }
    }
  }

  ${Editor.fragments.facility}
`;

const withFacilities = (Component) => {
  const FacilitiesWrapper = ({ enabledFacilities, ...rest }) => {
    const { locale } = useCurrentBuilderPage();

    const { data, loading: loadingFacilities } = useQuery(
      GET_FACILITIES, { variables: { live: true, locale } },
    );

    let facilities = [];
    if (data) {
      facilities = data.facilities.edges.map(({ node }) => node);
    }

    return (
      <Component
        facilities={facilities}
        loadingFacilities={loadingFacilities}
        enabledFacilities={enabledFacilities}
        locale={locale}
        {...rest}
      />
    );
  };

  FacilitiesWrapper.propTypes = {
  };

  FacilitiesWrapper.defaultProps = {
    enabledFacilities: undefined,
  };

  return FacilitiesWrapper;
};

export default withFacilities;
